import React, {Component} from 'react';
import {DeleteModal} from 'app-ui-componentlibrary';
import {filter, reduce} from 'lodash';
class RemoveRankModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: true,
    };
  }

  deleteCard = async () => {
    const {entityId, handleCardDelete, results} = this.props;
    const selectedItems = filter(results, (result) => result.checked === true);
    let entities;
    if (entityId) {
      entities = entityId;
    } else if (results) {
      entities = reduce(
        selectedItems,
        (result, row) => {
          result.push(row.entityId);
          return result;
        },
        []
      );
    }
    await handleCardDelete(entities);
    this.cancelAction();
  };

  cancelAction = () => {
    this.setState({
      modalOpen: false,
    });
    this.props.resetActions();
  };

  totalChecked = () => {
    return filter(this.props.results, (item) => item.checked).length || 1;
  };

  render() {
    return (
      <React.Fragment>
        <DeleteModal
          displayTitle={'Delete subapplication'}
          displayText={`Are you sure you want to delete ${this.totalChecked()} subapplication(s)?`}
          open={this.state.modalOpen}
          cancelAction={this.cancelAction}
          deleteAction={this.deleteCard}
          buttonText="Delete"
        />
      </React.Fragment>
    );
  }
}

export default RemoveRankModal;
